import occupations from "../../assets/data/occupations.json";
import LifeInsuranceIllustration from "../../components/custom/LifeInsuranceIllustration";
import { Theme } from "../../interfaces";
import { getApplicantSteps } from "../ApplicantSteps";
import DefaultSteps from "../DefaultSteps";
import AppointmentSteps from "../AppointmentSteps";
import CSQuestionnaire from "../cs-questionnaire";
import EscalationSteps from "../EscalationSteps";
import ProtectionSteps from "../ProtectionSteps";

const filterOccupation = (value: any, trigger: string) => {
  const filteredOccupations = occupations.filter((occupation) =>
    occupation.description.toLowerCase().includes(value.toLowerCase())
  );

  if (filteredOccupations.length) {
    return {
      key: trigger,
      value: filteredOccupations[0],
    };
  }

  return {
    key: trigger,
    value: { code: "DAB00651", description: "Doctor - Health" },
  };
};

const LifeInsuranceSteps = (theme: Theme) => {
  if (theme.customFlowData) {
    let mainFlow = theme.customFlowData.flow;
    if (theme.customFlowData.importedFlows) {
      const importedFlows = theme.customFlowData?.importedFlows.map(
        (data: any) => data.flow
      );
      let combinedImportedFlows: any = [];
      importedFlows.forEach((data: any) =>
        data.forEach((_data: any) => combinedImportedFlows.push(_data))
      );
      mainFlow = [...mainFlow, ...combinedImportedFlows];
    }

    return [
      ...mainFlow,
      {
        id: "pre_scan",
        type: "bot",
        message: "Great. That’s all I need. Let me just scan the market.",
        trigger: "life_insurance_illustration"
      },
      {
        id: "life_insurance_illustration",
        type: "bot",
        component: <LifeInsuranceIllustration />,
        end: true,
      },
      ...ProtectionSteps(theme),
      ...AppointmentSteps(theme),
      ...DefaultSteps(theme),
      ...getApplicantSteps(1),
      ...EscalationSteps,
      ...CSQuestionnaire(theme),
    ];
  }

  return [];
};

export default LifeInsuranceSteps;
